import { Link } from "react-router-dom";
import { inr } from "@/lib/api";
import { useCart } from "@/context/CartContext";
import { toast } from "sonner";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();

  const quickAdd = (e) => {
    e.preventDefault();
    const variant = product.variants?.[0];
    addItem({
      product_id: product.id,
      slug: product.slug,
      name: product.name,
      image: product.image,
      variant: variant?.label || "",
      price: variant?.price || product.price,
      quantity: 1,
    });
    toast.success(`${product.name} added to cart`);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group flex flex-col fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`product-card-${product.slug}`}
    >
      <div className="product-image-wrapper aspect-[4/5] bg-[#F4EFE6] relative">
        <img
          src={product.image}
          alt={product.name}
          className="product-image w-full h-full object-cover"
          loading="lazy"
        />
        <button
          onClick={quickAdd}
          data-testid={`quick-add-${product.slug}`}
          className="absolute bottom-0 left-0 right-0 bg-[#1C3326] text-[#FDFBF7] py-3 uppercase text-[10px] tracking-[0.3em] opacity-0 group-hover:opacity-100 transition-opacity duration-300"
        >
          Quick Add
        </button>
      </div>
      <div className="mt-5 flex flex-col gap-1">
        <div className="text-[10px] uppercase tracking-[0.25em] text-[#7B6F66]">
          {product.category === "single-origin" ? "Single Origin" : product.category}
          {product.roast_level ? ` · ${product.roast_level} Roast` : ""}
        </div>
        <div className="font-serif-display text-2xl text-[#2C1E16] leading-tight">
          {product.name}
        </div>
        <div className="text-sm text-[#7B6F66]">{product.tagline}</div>
        <div className="mt-2 text-[#1C3326] font-medium">
          from {inr(product.variants?.[0]?.price || product.price)}
        </div>
      </div>
    </Link>
  );
}
